import React from "react";
import Card from "@mui/material/Card";

// Argon Dashboard 2 MUI components
import ArgonBox from "components/ArgonBox";
import ArgonTypography from "components/ArgonTypography";

// Argon Dashboard 2 MUI examples
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import Table from "examples/Tables/Table";
import Grid from "@mui/material/Grid";
import ArgonButton from "components/ArgonButton";
import {
  FormControl,
  Select,
  LinearProgress,
  MenuItem,
  InputLabel,
  Chip,
  Button,
} from "@mui/material";
import { Person, Refresh, FilterList } from "@mui/icons-material";
// MUI

import breakpoints from "assets/theme/base/breakpoints";

// Data
import TutorsPayrollViewStudentTableData from "Views/Activities/TutorsPayroll/data/tutorsPayrollViewStudentTableData";

import CreditMappingViewTableData from "Views/Activities/CreditMapping/data/creditMappingViewTableData";
import CreditMappingViewCreditTableData from "Views/Activities/CreditMapping/data/creditMappingViewCreditTableData";
import TutorsParollViewPaymentOrderTableData from "Views/Activities/TutorsPayroll/data/tutorsPayrollViewPaymentOrderTableData";

// import ReferralTableData from "Views/Activities/Referral/data/ReferralTableData"
import { useState, useEffect } from "react";
import { set } from "date-fns";
import Dropdown from "components/CustomDropdown/Dropdown";
import ArgonInput from "components/ArgonInput";

function payroll({ classData }) {
  const { columns, rows } = TutorsPayrollViewStudentTableData;
  const { columns: columns1, rows: rows1 } = CreditMappingViewCreditTableData;
  const { columns: columns2, rows: rows2 } = TutorsParollViewPaymentOrderTableData;

  const [open, setOpen] = useState(false);

  const handleDeleteClick = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const [student, setStudent] = useState("");
  const [cycle, setCycle] = useState("");
  return (
    <ArgonBox mb={3}>
      <Card
        sx={{
          mt: 3,
          borderRadius: "20px",
          backgroundColor: "white",
          boxShadow: "0 8px 24px rgba(0,0,0,0.08)",
          border: "1px solid #f0f0f0",
          p: 3,
        }}
      >
        {/* Title */}
        <ArgonBox mb={3}>
          <ArgonTypography variant="h5" fontWeight="bold" color="dark">
            {"Tutor's Payroll Management"}
          </ArgonTypography>
          <ArgonTypography variant="body2" color="text">
            {"Manage tutor status, cycle, and payroll details"}
          </ArgonTypography>
        </ArgonBox>

        {/* Tutor Info Row */}
        <ArgonBox display="flex" alignItems="center" justifyContent="flex-start" gap={4} mb={3}>
          <ArgonTypography variant="body1" fontWeight="medium" color="dark">
            <strong>Tutor’s Name:</strong> Jane Smith
          </ArgonTypography>

          <ArgonBox
            display="flex"
            alignItems="center"
            px={2}
            py={0.5}
            sx={{
              background: "linear-gradient(135deg, #43a047, #26a69a)",
              borderRadius: "12px",
              boxShadow: "0 4px 10px rgba(67,160,71,0.25)",
            }}
          >
            <ArgonTypography
              variant="caption"
              fontWeight="bold"
              color="white"
              sx={{ fontSize: "13px", letterSpacing: "0.5px" }}
            >
              Ongoing
            </ArgonTypography>
          </ArgonBox>
        </ArgonBox>

        {/* Cycle Selector */}
        <ArgonBox display="flex" alignItems="center" gap={2}>
          <Dropdown
            label="Select Cycle"
            options={["1", "2", "3", "4"]}
            value={cycle}
            onChange={(e) => setCycle(e.target.value)}
          />
        </ArgonBox>
      </Card>

      <ArgonBox py={3}>
        <ArgonTypography variant="body1" fontWeight="medium" sx={{ px: 3 }} mb={2}>
          Student List
        </ArgonTypography>
        <ArgonBox
          sx={{
            "& .MuiTableRow-root:not(:last-child)": {
              "& td": {
                borderBottom: ({ borders: { borderWidth, borderColor } }) =>
                  `${borderWidth[1]} solid ${borderColor}`,
              },
            },
          }}
        >
          <Table columns={columns} rows={rows} />
        </ArgonBox>
      </ArgonBox>

      <Card
        sx={{
          mt: 3,
          borderRadius: "16px",
          backgroundColor: "white",
          boxShadow: "0 6px 20px rgba(0,0,0,0.08)",
          border: "1px solid #f0f0f0",
        }}
      >
        <ArgonBox p={3}>
          {/* Header */}
          <ArgonBox display="flex" alignItems="center" gap={2} mb={3}>
            <ArgonBox
              sx={{
                backgroundColor: "white",
                borderRadius: "12px",
                p: 1.2,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                boxShadow: "0 3px 8px rgba(0,0,0,0.08)",
              }}
            >
              {/* <Payment sx={{ color: "#344767", fontSize: "22px" }} /> */}
            </ArgonBox>
            <ArgonBox>
              <ArgonTypography variant="h5" fontWeight="bold" color="dark">
                Package
              </ArgonTypography>
              <ArgonTypography variant="body2" color="text">
                Package pricing and tutor salary details
              </ArgonTypography>
            </ArgonBox>
          </ArgonBox>

          <Grid container spacing={3}>
            {/* Hourly Rates */}
            <Grid item xs={12} md={4}>
              <ArgonBox
                sx={{
                  backgroundColor: "white",
                  borderRadius: "12px",
                  p: 2.5,
                  boxShadow: "0 4px 16px rgba(0,0,0,0.06)",
                  border: "1px solid #f5f5f5",
                  height: "100%",
                }}
              >
                <ArgonTypography variant="h6" fontWeight="bold" color="dark" mb={2}>
                  Hourly Rates
                </ArgonTypography>
                <ArgonBox display="flex" justifyContent="space-between" alignItems="center" mb={1}>
                  <ArgonTypography variant="body2" color="text" fontWeight="medium">
                    Fee Charge per hour
                  </ArgonTypography>
                  <ArgonTypography variant="body2" fontWeight="medium" color="dark">
                    ₹ 500
                  </ArgonTypography>
                </ArgonBox>
                <ArgonBox display="flex" justifyContent="space-between" alignItems="center" mb={1}>
                  <ArgonTypography variant="body2" color="text" fontWeight="medium">
                    Tutor Salary per hour
                  </ArgonTypography>
                  <ArgonTypography variant="body2" fontWeight="medium" color="dark">
                    ₹ 300
                  </ArgonTypography>
                </ArgonBox>
              </ArgonBox>
            </Grid>

            {/* Sessions */}
            <Grid item xs={12} md={4}>
              <ArgonBox
                sx={{
                  backgroundColor: "white",
                  borderRadius: "12px",
                  p: 2.5,
                  boxShadow: "0 4px 16px rgba(0,0,0,0.06)",
                  border: "1px solid #f5f5f5",
                  height: "100%",
                }}
              >
                <ArgonTypography variant="h6" fontWeight="bold" color="dark" mb={2}>
                  Sessions
                </ArgonTypography>
                <ArgonBox display="flex" justifyContent="space-between" alignItems="center" mb={1}>
                  <ArgonTypography variant="body2" color="text" fontWeight="medium">
                    Sessions in a week
                  </ArgonTypography>
                  <ArgonTypography variant="caption" fontWeight="medium" color="dark">
                    5 sessions | NaN Hours
                  </ArgonTypography>
                </ArgonBox>
                <ArgonBox display="flex" justifyContent="space-between" alignItems="center">
                  <ArgonTypography variant="body2" color="text" fontWeight="medium">
                    Sessions in a month
                  </ArgonTypography>
                  <ArgonTypography variant="caption" fontWeight="medium" color="dark">
                    sessions / Hours
                  </ArgonTypography>
                </ArgonBox>
              </ArgonBox>
            </Grid>

            {/* Monthly Summary */}
            <Grid item xs={12} md={4}>
              <ArgonBox
                sx={{
                  backgroundColor: "white",
                  borderRadius: "12px",
                  p: 2.5,
                  boxShadow: "0 4px 16px rgba(0,0,0,0.06)",
                  border: "1px solid #f5f5f5",
                  height: "100%",
                }}
              >
                <ArgonTypography variant="h6" fontWeight="bold" color="dark" mb={2}>
                  Monthly Summary
                </ArgonTypography>
                <Grid container spacing={2}>
                  <Grid item xs={6}>
                    <ArgonBox textAlign="center">
                      <ArgonTypography variant="caption" color="text">
                        Monthly Charge
                      </ArgonTypography>
                      <ArgonTypography variant="h6" fontWeight="bold" color="dark">
                        ₹ 20000
                      </ArgonTypography>
                    </ArgonBox>
                  </Grid>
                  <Grid item xs={6}>
                    <ArgonBox textAlign="center">
                      <ArgonTypography variant="caption" color="text">
                        Pay
                      </ArgonTypography>
                      <ArgonTypography variant="h6" fontWeight="bold" color="dark">
                        ₹ 12000
                      </ArgonTypography>
                    </ArgonBox>
                  </Grid>
                </Grid>
              </ArgonBox>
            </Grid>
          </Grid>

          {/* Tutor Info */}
          <ArgonBox mt={3}>
            <ArgonTypography variant="body2" fontWeight="bold" color="dark">
              Tutor Name - Jane Smith
            </ArgonTypography>
          </ArgonBox>
        </ArgonBox>
      </Card>

      <Card
        sx={{
          mt: 3,
          borderRadius: "16px",
          backgroundColor: "white",
          boxShadow: "0 6px 20px rgba(0,0,0,0.08)",
          border: "1px solid #f0f0f0",
        }}
      >
        <ArgonBox p={3}>
          {/* Header */}
          <ArgonBox display="flex" alignItems="center" justifyContent="space-between" mb={3}>
            <ArgonTypography variant="h5" fontWeight="bold" color="dark">
              Attendance Overview
            </ArgonTypography>

            <ArgonBox display="flex" gap={2}>
              <ArgonButton
                variant="contained"
                color="primary"
                sx={{
                  backgroundColor: "rgb(8, 2, 120)",
                  textTransform: "none",
                  px: 2.5,
                  py: 1,
                  fontWeight: "bold",
                  borderRadius: "10px",
                }}
                href="/admin/tutorpayroll/view/1/101"
              >
                Details View
              </ArgonButton>
              <ArgonButton
                variant="contained"
                color="primary"
                sx={{
                  backgroundColor: "rgb(8, 2, 120)",
                  textTransform: "none",
                  px: 2.5,
                  py: 1,
                  fontWeight: "bold",
                  borderRadius: "10px",
                }}
                href="/admin/creditmapping/creditmapping-view/tutors-replacement"
              >
                Replace Tutors
              </ArgonButton>
            </ArgonBox>
          </ArgonBox>

          {/* Progress Section */}
          <Grid container spacing={3} mb={3}>
            <Grid item xs={12} md={5}>
              <ArgonBox>
                <ArgonTypography variant="body2" fontWeight="bold" color="text" mb={1}>
                  No. Of Sessions Completed 10 / 20
                </ArgonTypography>
                <LinearProgress
                  variant="determinate"
                  value={50}
                  sx={{
                    height: 12,
                    borderRadius: "6px",
                    backgroundColor: "#f0f0f0",
                    "& .MuiLinearProgress-bar": {
                      backgroundColor: "#1976d2",
                      borderRadius: "6px",
                    },
                  }}
                />
                <ArgonTypography variant="caption" color="dark" fontWeight="medium" mt={1}>
                  50%
                </ArgonTypography>
              </ArgonBox>
            </Grid>

            <Grid item xs={12} md={2}></Grid>

            <Grid item xs={12} md={5}>
              <ArgonBox>
                <ArgonTypography variant="body2" fontWeight="bold" color="text" mb={1}>
                  Remaining Sessions
                </ArgonTypography>
                <ArgonTypography variant="h6" fontWeight="bold" color="dark">
                  10
                </ArgonTypography>
              </ArgonBox>
            </Grid>
          </Grid>

          {/* Expiry Warning */}
          <ArgonBox
            mt={2}
            display="flex"
            alignItems="center"
            justifyContent="center"
            textJustify="center"
            marginLeft="240px"
            sx={{
              width: "50%",
              border: "2px solid #f44336",
              borderRadius: "12px",
              p: 1,
              backgroundColor: "#fff5f5",
            }}
          >
            <i
              className="fa-solid fa-triangle-exclamation"
              style={{ color: "red", fontSize: "22px", marginRight: "12px" }}
            ></i>
            <ArgonTypography variant="body2" fontWeight="bold" color="dark">
              Your Class Cycle will Expire in Approx -700 Days
            </ArgonTypography>
          </ArgonBox>
        </ArgonBox>
      </Card>

      <Card
        sx={{
          mt: 3,
          borderRadius: "20px",
          backgroundColor: "white",
          boxShadow: "0 15px 35px rgba(0,0,0,0.08)",
          border: "1px solid #f0f0f0",
          position: "relative",
          overflow: "hidden",
        }}
      >
        {/* Decorative Background Element */}
        <ArgonBox
          sx={{
            position: "absolute",
            top: -40,
            right: -40,
            width: 120,
            height: 120,
            background: "linear-gradient(45deg, #667eea, #764ba2)",
            borderRadius: "50%",
            opacity: 0.05,
          }}
        />

        <ArgonBox p={4}>
          {/* Header */}
          <ArgonBox display="flex" alignItems="center" gap={2} mb={4}>
            <ArgonBox
              sx={{
                background: "linear-gradient(45deg, #667eea, #764ba2)",
                borderRadius: "12px",
                p: 1.5,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                boxShadow: "0 4px 15px rgba(102, 126, 234, 0.3)",
              }}
            >
              {/* <AccountBalance sx={{ color: "white", fontSize: "22px" }} /> */}
            </ArgonBox>
            <ArgonBox>
              <ArgonTypography variant="h5" fontWeight="bold" color="#2c3e50">
                Credit Counter
              </ArgonTypography>
              <ArgonTypography variant="body2" color="#6c757d">
                Track credits, usage and payments
              </ArgonTypography>
            </ArgonBox>
          </ArgonBox>

          <Grid container spacing={4}>
            {/* Progress Bar Section */}
            <Grid item xs={12} md={6}>
              <ArgonBox
                sx={{
                  background: "#f8f9fa",
                  borderRadius: "16px",
                  p: 3,
                  textAlign: "center",
                  border: "1px solid #e9ecef",
                }}
              >
                <ArgonBox
                  display="flex"
                  alignItems="center"
                  gap={1.5}
                  mb={3}
                  justifyContent="center"
                >
                  {/* <DonutLarge sx={{ color: "#2196F3", fontSize: "20px" }} /> */}
                  <ArgonTypography variant="h6" fontWeight="bold" color="#2c3e50">
                    Usage Progress
                  </ArgonTypography>
                </ArgonBox>

                <ArgonBox
                  sx={{
                    width: 180,
                    height: 180,
                    margin: "0 auto",
                    mb: 2,
                  }}
                >
                  <svg viewBox="0 0 100 100" style={{ width: "100%", height: "100%" }}>
                    <path
                      d="M 50,50 m 0,-46 a 46,46 0 1 1 0,92 a 46,46 0 1 1 0,-92"
                      strokeWidth="6"
                      fillOpacity="0"
                      style={{ stroke: "#e0e0e0" }}
                    />
                    <path
                      d="M 50,50 m 0,-46 a 46,46 0 1 1 0,92 a 46,46 0 1 1 0,-92"
                      strokeWidth="6"
                      fillOpacity="0"
                      style={{
                        stroke: "url(#gradient)",
                        strokeDasharray: "289.027px, 289.027px",
                        strokeDashoffset: "280.356px",
                        strokeLinecap: "round",
                      }}
                    />
                    <defs>
                      <linearGradient id="gradient" x1="0%" y1="0%" x2="100%" y2="0%">
                        <stop offset="0%" style={{ stopColor: "#667eea", stopOpacity: 1 }} />
                        <stop offset="100%" style={{ stopColor: "#764ba2", stopOpacity: 1 }} />
                      </linearGradient>
                    </defs>
                    <text
                      x="50"
                      y="45"
                      textAnchor="middle"
                      alignmentBaseline="central"
                      style={{ fill: "#2c3e50", fontSize: "12px", fontWeight: "bold" }}
                    >
                      3%
                    </text>
                    <text
                      x="50"
                      y="58"
                      textAnchor="middle"
                      alignmentBaseline="central"
                      style={{ fill: "#6c757d", fontSize: "6px" }}
                    >
                      Used
                    </text>
                  </svg>
                </ArgonBox>

                <ArgonBox>
                  <ArgonTypography variant="h5" fontWeight="bold" color="#2c3e50">
                    ₹200 / ₹6000
                  </ArgonTypography>
                  <ArgonTypography variant="body2" color="#6c757d">
                    Credit Usage
                  </ArgonTypography>
                </ArgonBox>
              </ArgonBox>
            </Grid>

            {/* Table Section */}
            <Grid item xs={12} md={6}>
              <ArgonBox
                sx={{
                  background: "white",
                  borderRadius: "16px",
                  p: 3,
                  boxShadow: "0 8px 25px rgba(0,0,0,0.06)",
                  border: "1px solid #f0f0f0",
                }}
              >
                <ArgonBox display="flex" alignItems="center" gap={1.5} mb={3}>
                  {/* <TableChart sx={{ color: "#4CAF50", fontSize: "20px" }} /> */}
                  <ArgonTypography variant="h6" fontWeight="bold" color="#2c3e50">
                    Credit Details
                  </ArgonTypography>
                </ArgonBox>

                <ArgonBox
                  sx={{
                    "& .MuiTableRow-root:not(:last-child)": {
                      "& td": {
                        borderBottom: ({ borders: { borderWidth, borderColor } }) =>
                          `${borderWidth[1]} solid ${borderColor}`,
                      },
                    },
                  }}
                >
                  <Table columns={columns1} rows={rows1} />
                </ArgonBox>
              </ArgonBox>
            </Grid>
          </Grid>

          <Grid container spacing={3} mt={2} alignItems="stretch">
            {/* Account Summary */}
            <Grid item xs={12} md={4}>
              <Card
                sx={{
                  height: "100%",
                  borderRadius: "16px",
                  backgroundColor: "white",
                  boxShadow: "0 6px 20px rgba(0,0,0,0.08)",
                  border: "1px solid #f0f0f0",
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                <ArgonBox p={3} flexGrow={1}>
                  <ArgonTypography variant="h6" fontWeight="bold" color="dark" mb={2}>
                    Account Summary
                  </ArgonTypography>

                  <ArgonBox display="flex" justifyContent="space-between" mb={1.5}>
                    <ArgonTypography variant="body2" color="text" fontWeight="medium">
                      Balance:
                    </ArgonTypography>
                    <ArgonTypography variant="body2" fontWeight="bold" color="primary">
                      NaN
                    </ArgonTypography>
                  </ArgonBox>

                  <ArgonBox display="flex" justifyContent="space-between" mb={1.5}>
                    <ArgonTypography variant="body2" color="text" fontWeight="medium">
                      Unallocated Sessions:
                    </ArgonTypography>
                    <Chip
                      label="40"
                      size="small"
                      sx={{
                        bgcolor: "primary.main",
                        color: "white",
                        fontWeight: "600",
                      }}
                    />
                  </ArgonBox>

                  <ArgonBox display="flex" justifyContent="space-between">
                    <ArgonTypography variant="body2" color="text" fontWeight="medium">
                      Usually Pays By:
                    </ArgonTypography>
                    <Chip
                      label="UPI"
                      size="small"
                      sx={{
                        bgcolor: "success.main",
                        color: "white",
                        fontWeight: "600",
                      }}
                    />
                  </ArgonBox>
                </ArgonBox>
              </Card>
            </Grid>

            {/* Payment Details */}
            <Grid item xs={12} md={4}>
              <Card
                sx={{
                  height: "100%",
                  borderRadius: "16px",
                  backgroundColor: "white",
                  boxShadow: "0 6px 20px rgba(0,0,0,0.08)",
                  border: "1px solid #f0f0f0",
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                <ArgonBox p={3} flexGrow={1}>
                  <ArgonTypography variant="h6" fontWeight="bold" color="dark" mb={2}>
                    Payment Details
                  </ArgonTypography>

                  <ArgonBox display="flex" justifyContent="space-between" mb={1.5}>
                    <ArgonTypography variant="body2" color="text" fontWeight="medium">
                      Available Balance:
                    </ArgonTypography>
                    <ArgonTypography variant="body2" fontWeight="bold" color="success.dark">
                      ₹0
                    </ArgonTypography>
                  </ArgonBox>

                  <ArgonBox display="flex" justifyContent="space-between" mb={1.5}>
                    <ArgonTypography variant="body2" color="text" fontWeight="medium">
                      Number of Payments:
                    </ArgonTypography>
                    <Chip
                      label="0"
                      size="small"
                      sx={{
                        bgcolor: "warning.main",
                        color: "white",
                        fontWeight: "600",
                      }}
                    />
                  </ArgonBox>

                  <ArgonBox display="flex" justifyContent="space-between">
                    <ArgonTypography variant="body2" color="text" fontWeight="medium">
                      Total Paid:
                    </ArgonTypography>
                    <ArgonTypography variant="body2" fontWeight="bold" color="success.dark">
                      ₹0
                    </ArgonTypography>
                  </ArgonBox>
                </ArgonBox>
              </Card>
            </Grid>

            {/* Bank Details */}
            <Grid item xs={12} md={4}>
              <Card
                sx={{
                  height: "100%",
                  borderRadius: "16px",
                  backgroundColor: "white",
                  boxShadow: "0 6px 20px rgba(0,0,0,0.08)",
                  border: "1px solid #f0f0f0",
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                <ArgonBox p={3} flexGrow={1}>
                  <ArgonTypography variant="h6" fontWeight="bold" color="dark" mb={2}>
                    Bank Details
                  </ArgonTypography>

                  <Grid container spacing={2}>
                    <Grid item xs={12}>
                      <ArgonBox display="flex" justifyContent="space-between">
                        <ArgonTypography variant="body2" color="text" fontWeight="medium">
                          Usually Pays:
                        </ArgonTypography>
                        <ArgonTypography variant="h6" fontWeight="bold" color="dark">
                          UPI
                        </ArgonTypography>
                      </ArgonBox>
                    </Grid>

                    <Grid item xs={12}>
                      <ArgonBox display="flex" justifyContent="space-between">
                        <ArgonTypography variant="body2" color="text" fontWeight="medium">
                          Salary Owed:
                        </ArgonTypography>
                        <ArgonTypography variant="h6" fontWeight="bold" color="dark">
                          ₹ 8000/-
                        </ArgonTypography>
                      </ArgonBox>
                    </Grid>

                    <Grid item xs={12}>
                      <ArgonBox display="flex" justifyContent="space-between">
                        <ArgonTypography variant="body2" color="text" fontWeight="medium">
                          Number of Payments:
                        </ArgonTypography>
                        <ArgonTypography variant="h6" fontWeight="bold" color="dark">
                          2
                        </ArgonTypography>
                      </ArgonBox>
                    </Grid>
                  </Grid>
                </ArgonBox>
              </Card>
            </Grid>
          </Grid>

          <ArgonBox mt={4}>
            <ArgonTypography mb={2} variant="body2" fontWeight="medium" color="dark">
              Total Payment Orders
            </ArgonTypography>

            <ArgonBox
              sx={{
                "& .MuiTableRow-root:not(:last-child)": {
                  "& td": {
                    borderBottom: ({ borders: { borderWidth, borderColor } }) =>
                      `${borderWidth[1]} solid ${borderColor}`,
                  },
                },
              }}
            >
              <Table columns={columns2} rows={rows2} />
            </ArgonBox>
          </ArgonBox>
        </ArgonBox>
      </Card>
    </ArgonBox>
  );
}

export default payroll;
